import { extendTheme } from '@chakra-ui/react';

const colors = {
  brand: {
    50: '#e2f4ff',
    100: '#b3dbff',
    200: '#84c2ff',
    300: '#55a9ff',
    400: '#2690ff',
    500: '#0c76e6',
    600: '#085bb4',
    700: '#054082',
    800: '#022651',
    900: '#000d21',
  },
};

const fonts = {
  heading: "'Open Sans', sans-serif",
  body: "'Open Sans', sans-serif",
};

const config = {
  initialColorMode: 'light',
  useSystemColorMode: true, // rešpektuje systémové nastavenie
};

const theme = extendTheme({ colors, fonts, config });

export default theme;
